import { render, staticRenderFns } from "./termsModel.vue?vue&type=template&id=710c04d1&scoped=true&lang=pug&"
import script from "./termsModel.vue?vue&type=script&lang=js&"
export * from "./termsModel.vue?vue&type=script&lang=js&"
import style0 from "./termsModel.vue?vue&type=style&index=0&id=710c04d1&lang=scss&scoped=true&"
import style1 from "./termsModel.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710c04d1",
  null
  
)

export default component.exports